import React from 'react';
import { CusProductListCategoryNavigationProps } from '../cus-product-list.data';
import useCategoryNavigation from '../hooks/useCategoryNavigation';

export default function CategoryNavigation({ response, subCategoriesAriaLabel }: CusProductListCategoryNavigationProps) {
    const { containerRef, currentCategory, navigationItems, parentCategory } = useCategoryNavigation({ response });

    if (!currentCategory) {
        return null;
    }

    return (
        <nav aria-label={subCategoriesAriaLabel} className='bs-subcategory__nav'>
            {!!parentCategory && (
                <a className='bs-subcategory__parent' href={parentCategory.url}>
                    <span aria-hidden='true'>←</span>
                    <span>{parentCategory.displayName}</span>
                </a>
            )}
            <ul className='bs-subcategory__container' ref={containerRef}>
                <li className='bs-subcategory__item --active' key={currentCategory.recordId}>
                    <span aria-current='page'>{currentCategory.displayName}</span>
                </li>

                {navigationItems?.length > 0 &&
                    navigationItems.map(category => {
                        if (category.recordId === currentCategory.recordId) {
                            return null;
                        }

                        return (
                            <li className='bs-subcategory__item' key={category.recordId}>
                                <a href={category.url}>{category.displayName}</a>
                            </li>
                        );
                    })}
            </ul>
        </nav>
    );
}
